export enum InputSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}
